export default "__VITE_ASSET__2aaaf90d__"